import { useMutation } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";

export const useCheckUserExist = () => {
  return useMutation({
    mutationFn: async (email) => {
      console.log("Email received in checkIfUserExists:", email);
      try {
        const response = await fetch(
          `${WiMuleSQL}/api/Auth/CheckIfFirebaseUserExist?email=${email}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Running check on ", email);
        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        } else {
          console.log("User exists:");
          return true;
        }
      } catch (error) {
        throw new Error(error.message);
      }
    },
  });
};
